import {createInjectionState} from '@vueuse/core';
import {computed, useId, type ComputedRef} from 'vue';
import type {BaseValidation} from '@vuelidate/core';

type FormInputStateOptions = {
    disabled?: boolean;
    helpText?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    validator?: BaseValidation<any>;
};

const [provideState, injectState] = createInjectionState(
    (options: ComputedRef<FormInputStateOptions>) => {
        const inputId = useId();

        const showErrors = computed(
            () => options.value.validator?.$dirty && options.value.validator.$invalid
        );

        const describedBy = computed(() => {
            const ids = [];
            if (options.value.helpText) ids.push(`${inputId}-help`);
            if (showErrors.value && options.value.validator?.$errors.length)
                ids.push(`${inputId}-errors`);
            return ids.join(' ') || undefined;
        });

        const disabled = computed(() => options.value.disabled ?? false);

        return {inputId, showErrors, describedBy, disabled};
    }
);

export const provideFormInputState = provideState;

export function injectFormInputState() {
    return injectState();
}
